const FEATURE_HELP_URLS = {
  agent_bots: 'https://rzcm.app/hc/agent-bots',
  agents: 'https://rzcm.app/hc/agents',
  audit_logs: 'https://rzcm.app/hc/audit-logs',
  campaigns: 'https://rzcm.app/hc/campaigns',
  canned_responses: 'https://rzcm.app/hc/canned',
  channel_email: 'https://rzcm.app/hc/email',
  channel_facebook: 'https://rzcm.app/hc/fb',
  custom_attributes: 'https://rzcm.app/hc/custom-attributes',
  dashboard_apps: 'https://rzcm.app/hc/dashboard-apps',
  help_center: 'https://rzcm.app/hc/help-center',
  inboxes: 'https://rzcm.app/hc/inboxes',
  integrations: 'https://rzcm.app/hc/integrations',
  labels: 'https://rzcm.app/hc/labels',
  macros: 'https://rzcm.app/hc/macros',
  message_reply_to: 'https://rzcm.app/hc/reply-to',
  reports: 'https://rzcm.app/hc/reports',
  sla: 'https://rzcm.app/hc/sla',
  team_management: 'https://rzcm.app/hc/teams',
  webhook: 'https://rzcm.app/hc/webhooks',
  billing: 'https://rzcm.app/pricing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
